import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";

const CampaignOfferTypeModal = props => {
  const {
    isOpen,
    toggle,
    data,
    addCampaignOfferType,
    updateCampaignOfferTypeProfile,
    editData,
  } = props;

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let offerType = {
        ...params,
      };

      if (editData !== null) {
        updateCampaignOfferTypeProfile(editData.id, offerType, data);
        toggle();
      } else {
        addCampaignOfferType(offerType, data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus centered toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} campaign offer type
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <FormGroup className="mb-3">
                <Label>Offer type name</Label>
                <AvField
                  name="name"
                  type="text"
                  errorMessage="This value is required."
                  value={editData?.name || ""}
                  placeholder="Offer type name..."
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter description",
                    },
                    maxLength: {
                      value: 15,
                      errorMessage: "Max 15 characters.",
                    },
                  }}
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Description</Label>
                <AvField
                  name="description"
                  type="text"
                  placeholder="Description..."
                  errorMessage="This value is required."
                  value={editData?.description || ""}
                  validate={{
                    required: {
                      value: false,
                    },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_campaignoffertypemodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

CampaignOfferTypeModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  addCampaignOfferType: PropTypes.func,
  updateCampaignOfferTypeProfile: PropTypes.func,
  editData: PropTypes.any,
  permissions: PropTypes.any,
};

export default CampaignOfferTypeModal;
